import { connect } from 'react-redux';

import DemoSelfService from 'presentation/components/__demo__/DemoSelfService.jsx';
import { getSelectedAnswer } from 'app/modules';

export const mapStateToProps = state => {
  return {
    isAnswerSelected: !!getSelectedAnswer(state),
  };
};

const DemoSelfServiceContainer = connect(mapStateToProps)(DemoSelfService);

export default DemoSelfServiceContainer;
